module.exports = __webpack_public_path__ + "static/25-billionusers-dec2005-717de693557440ce44c9c05941094668.jpg";